export enum AuthorityShedule {
  SHEDULE_EVERYTHING_VIEW = '15.1.4',
}
